import React, { Fragment } from "react";
import { withStyles } from "tss-react/mui";
import { redColor } from "~/assets/jss/globalStyle";
import { Button } from "~/components";

// eslint-disable-next-line
const styles = (theme, props) => ({
  container: {
    textAlign: "center",
  },
  header: {
    fontSize: "20px",
    fontWeight: 600,
  },
  deleteWarning: {
    fontSize: "14px",
    color: redColor,
  },
});

interface ConfirmationProps {
  buttonLabel?: string;
  handleClose: React.MouseEventHandler<HTMLButtonElement>;
  handleConfirmation: React.MouseEventHandler<HTMLButtonElement>;
  header: string;
  classes?: Partial<Record<"container" | "header", string>>;
}

const Confirmation = (props: ConfirmationProps) => {
  const {
    buttonLabel = "Yes",
    handleClose,
    handleConfirmation,
    header,
  } = props;
  const classes = withStyles.getClasses(props);

  return (
    <Fragment>
      <div className={classes.container}>
        <h5 className={classes.header}>{header}</h5>
        <Button label="Cancel" isTextButton onClick={handleClose} />
        <Button label={buttonLabel} isBlue onClick={handleConfirmation} />
      </div>
    </Fragment>
  );
};
export default withStyles(Confirmation, styles);
